<template>
  <div class="flex flex-wrap justify-center items-center" v-bind="$attrs">
    <CommonStarsRating color="#00a1aa" :value="customerReview.average_review" />

    <NuxtLinkLocale
      class="cursor-pointer"
      :to="props.preventNavigation ? '#' : '/reviews'"
      :locale="switchBlogLocale()"
      @click="handleClick"
    >
      <span class="text-sm whitespace-nowrap underline ml-2" :class="props.textColorClass">
        {{
          $t("reviewBlock.basedOnText", {
            totalReviews: customerReview.total_reviews,
          })
        }}
      </span>
    </NuxtLinkLocale>
  </div>
</template>

<script setup lang="ts">
defineOptions({
  inheritAttrs: false,
});

const props = defineProps({
  preventNavigation: {
    type: Boolean,
    default: false,
  },
  textColorClass: {
    type: String,
    default: "text-current", // Inherits color from parent by default
  },
});

const emit = defineEmits(["clicked"]);

const handleClick = (event: MouseEvent) => {
  emit("clicked");
};

const customerReview = ref();

const { data: homeData } = await useHomePage();
if (homeData.value) {
  customerReview.value = homeData.value?.meta;
}
</script>
